ActivityFeedComponent = require 'views/member/activity-feed-component'
ApiError = require 'network/api-error'
Auth = require 'db/auth'
Card = require 'models/card'
ModelLoader = require 'db/model-loader'
React = require 'react'
recup = require 'recup'
startDecayingInterval = require 'lib/util/decaying-interval'
t = require('views/internal/recup-with-helpers')()
TFM = require 'lib/markdown/tfm'
track = require 'debug/track'
Util = require 'lib/util'

module.exports = class ActivityFeedContainer extends React.Component
  displayName: 'ActivityFeedContainer'

  constructor: (props) ->
    super props
    @showUnreadActions = @showUnreadActions.bind(@)
    @renderActivities = @renderActivities.bind(@)
    @filterActivityFeed = @filterActivityFeed.bind(@)
    @loadMoreActivities = @loadMoreActivities.bind(@)

    @state = {
      actions: []
      mostRecentActionId: ''
      filterBy: ''
      unreadActions: []
      loadingNew: true
      loadingMore: false
      moreActivitiesLength: 0
    }

  componentDidMount: ->
    @fetchActivities({}).then (actions) =>
      @setState
        actions: actions
        mostRecentActionId: if actions?.length then actions[0].id else ''
      @startPollingforActivities()
    .catch (e) => console.error e
    .finally =>
      @setState
        loadingNew: false

  componentWillUnmount: ->
    @cancelDecayingInterval()

  fetchActivities: ({ before, since, filter }) ->
    ModelLoader.loadActivityFeed({ before, since, filter })
      .then (actions) =>
        actions.map (action) =>
          {
            id: action.id
            card: new Card(action.get('card'), modelCache: @props.modelCache),
            memberCreator: @props.modelCache.get('Member', action.get('idMemberCreator'))?.toJSON(),
            isAddAttachment: action.isAddAttachment(),
            isCommentLike: action.isCommentLike(),
            entity:
              type: 'comment'
              textHtml: TFM.comments.format(action.get('data').text).output
              date: action.get('date')
          }
      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        console.error e
        []

  renderActivities: ->
    @fetchActivities({ since: @state.mostRecentActionId, filter: @state.filterBy }).then (newActions) =>
      if newActions.length
        @setState (prevState, props) ->
          unreadActions: newActions.concat prevState.unreadActions
          mostRecentActionId: newActions[0].id

  startPollingforActivities: ->
    @cancelDecayingInterval = startDecayingInterval(@renderActivities)

  showUnreadActions: (e) ->
    Util.preventDefault(e)
    track('Boards View', 'Activity Feed', 'Show unread activities')
    @setState (prevState, props) ->
      actions: prevState.unreadActions.concat prevState.actions
      unreadActions: []
      mostRecentActionId: prevState.unreadActions[0].id

  filterActivityFeed: (filterVal) ->
    @setState
      loadingNew: true
    @cancelDecayingInterval()
    @fetchActivities({ filter: filterVal }).then (actions) =>
      @setState
        actions: actions
        mostRecentActionId: if actions?.length then actions[0].id else ''
        filterBy: filterVal
      @startPollingforActivities()
    .catch (e) -> console.error e
    .finally =>
      @setState
        loadingNew: false

  loadMoreActivities: (e) ->
    Util.preventDefault(e)
    track('Boards View', 'Activity Feed', 'Load more activities')
    @setState
      loadingMore: true
    @fetchActivities({ filter: @state.filterBy, before: @state.actions[@state.actions.length - 1].id }).then (actions) =>
      @setState (prevState, props) ->
        actions: prevState.actions.concat(actions)
        moreActivitiesLength: actions.length
    .catch (e) => console.error e
    .finally =>
      @setState
        loadingMore: false

  render: t.renderable ->
    { actions, unreadActions, filterBy, loadingNew, loadingMore, moreActivitiesLength } = @state
    recup.createElement ActivityFeedComponent, {
      @filterActivityFeed
      @loadMoreActivities
      @showUnreadActions
      actions
      filterBy
      loadingMore
      loadingNew
      moreActivitiesLength
      organizationList: Auth.me()?.organizationList?.models
      unreadActions
    }



// WEBPACK FOOTER //
// ./app/scripts/views/member/activity-feed-container.coffee